import { Row } from "reactstrap";
import { H3, Image, P } from "../../../../AbstractElements";
import { Designer, MarkJecno } from "../../../../Constant";
import { dynamicImage } from "../../../../Service/DynamicImage";

export const UserFormHead = () => {
  return (
    <Row className="mb-2">
      <div className="profile-title">
        <div className="d-flex">
          <Image className="img-70 rounded-circle" alt="" src={dynamicImage("user/7.jpg")} />
          <div className="flex-grow-1">
            <H3 className="mb-1">{MarkJecno}</H3>
            <P>{Designer}</P>
          </div>
        </div>
      </div>
    </Row>
  );
};
